module.exports = __webpack_public_path__ + "media/src/images/mails/green_tick-86d9fca33d6606357d0602fb14aef156.png";